import { render, staticRenderFns } from "./edit-cmt.vue?vue&type=template&id=65cd2f0a&"
import script from "./edit-cmt.vue?vue&type=script&lang=js&"
export * from "./edit-cmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports